'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SpacerElement = require('../../internal/SpacerElement');

var _SpacerElement2 = _interopRequireDefault(_SpacerElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A general purpose spacer component for wrapping multiple components with
 * some spacing. Used for simple use-cases where spacing doesn't change
 * based on screen size or device.
 */
var Spacer = function Spacer(props) {
  return _react2.default.createElement(
    _SpacerElement2.default,
    _extends({ element: 'div' }, props),
    props.children
  );
};

Spacer.displayName = 'Spacer';
Spacer.propTypes = _extends({
  children: _propTypes2.default.node.isRequired
}, _SpacerElement2.default.propTypes);

Spacer.defaultProps = _extends({}, _SpacerElement2.default.defaultProps);

exports.default = Spacer;